module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAATlJREFUOBGdlb1uwjAURuNODJVYOjEztYIpY5fCgHgNXrJTOzFGGZAq9QmqDh0r1vAdE0cG/Beu5Njx9Xdi32s7VSVr2/a5aZon2vcYWhhojV4Wqj+NMT9d163ruv4bAwUm7Ye0M+lWD3pM1TFRxxLHmJl6MLQTy2I2cryq413QR9WHkplewf6l2Wp1ewMQGwONweAMwFJoCnYDzEFzsCAwBrWDz9kkAUPM6PftYsm+w4+p+r9630sKxpgoEOcVtMrB0LAPU/Yt5683gDZ9UYsCvQTMNbMjRXuNdnLzB4EezCVgI9imX3LyRN3EMACzJ4A1+jEVPHiiLoApmAtaDjoAS2AlUAscA8tBuQ/dfeYSMMTMiWN1aPlk+U1l0WewGMZHuK64ttDCUIFlfwE7vmZf7nig1S9gh/QEo+hokM93I2UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/close.png
// module id = 481
// module chunks = 1